import axios from "axios";

const publicApi = axios.create({
  baseURL: "https://centromillennials.com/api",
});

export default publicApi;
